import React, { useContext } from "react";
import TimeTableContext from "../../context/timeTableContext";

const Nav = () => {
  const context = useContext(TimeTableContext);

  return (
    <nav
      className="navbar navbar-expand-md navbar-dark bg-dark"
      style={context.state.showNavBar
        ? { display: "flex" }
        : { display: "none" }}
    >
      <a className="navbar-brand" href="/">
        <img
          height="35"
          src="https://my.schooly.co.il/schoolyLogo.png"
          alt=""
        />
      </a>
      <div className="navbar-nav">
        <button
          className="nav-item nav-link btn btn-link"
          onClick={(e) => {
            context.dispatch({ type: "SET_CURRENT_SCREEN", payload: 1 });
            context.dispatch({ type: "SET_NAV_DISPLAY", payload: false });
          }}
        >
          מערכת שעות{" "}
        </button>
        <button
          className="nav-item nav-link btn btn-link"
          onClick={(e) => {
            context.dispatch({ type: "SET_CURRENT_SCREEN", payload: 2 });
            context.dispatch({ type: "SET_NAV_DISPLAY", payload: false });
          }}
        >
          מערכת שעות ושינויים
        </button>
        <button
          className="nav-item nav-link btn btn-link"
          onClick={(e) => {
            context.dispatch({ type: "SET_CURRENT_SCREEN", payload: 3 });
            context.dispatch({ type: "SET_NAV_DISPLAY", payload: false });
          }}
        >
          תצוגת שינויים
        </button>
        <button
          className="nav-item nav-link btn btn-link"
          onClick={(e) => {
            context.dispatch({ type: "SET_CURRENT_SCREEN", payload: 4 });
            context.dispatch({ type: "SET_NAV_DISPLAY", payload: false });
          }}
        >
          מערכת שעות (יומי)
        </button>
        <button
          className="nav-item nav-link btn btn-link"
          onClick={(e) => {
            context.dispatch({ type: "SET_CURRENT_SCREEN", payload: 5 });
            context.dispatch({ type: "SET_NAV_DISPLAY", payload: false });
          }}
        >
          תצוגת שינויים בטבלה (יומי)
        </button>
        <div style={{ fontSize: "12px", position: "absolute", left: "0", color: "white" }}>גירסה - {context.state.version}</div>

      </div>
    </nav>
  );
};
export default Nav;
